// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hb8Om","colBig":"styles_colBig__1GiLP","colSmall":"styles_colSmall__2G-Do"};